import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { createElement } from 'react';

import '@js-joda/locale_en-us';
import '@js-joda/timezone';
import { configure } from '@teamexos/fit-shared';
import { createRoot } from 'react-dom/client';
import config from '../aws-exports';
import Providers from '../Providers';
import './app.css';
import { BrowserRouter } from './routes';

if (process.env.NODE_ENV !== 'production') {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

if (
  process.env.NODE_ENV !== 'development' &&
  process.env.DD_APPLICATION_ID &&
  process.env.DD_CLIENT_TOKEN
) {
  datadogRum.init({
    applicationId: process.env.DD_APPLICATION_ID,
    clientToken: process.env.DD_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'coach-hub',
    env: process.env.GATSBY_ENV_LEVEL === 'prod' ? 'prod' : 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: process.env.GATSBY_ENV_LEVEL === 'prod' ? 100 : 0,
    traceSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    version: process.env.GATSBY_COMMIT_ID,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
  });
  datadogLogs.init({
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'coach-hub',
    env: process.env.GATSBY_ENV_LEVEL === 'prod' ? 'prod' : 'dev',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: process.env.GATSBY_COMMIT_ID,
  });
}

configure(config[process.env.GATSBY_ENV_LEVEL ?? 'dev']);

const RenderIt = () => (
  <Providers>
    <BrowserRouter />
  </Providers>
);

let container: HTMLElement | null;

document.addEventListener('DOMContentLoaded', () => {
  if (!container) {
    container = document.getElementById('root');
    if (container) {
      const root = createRoot(container, {
        onUncaughtError: (err) => {
          if (process.env.NODE_ENV === 'development') {
            // biome-ignore lint/suspicious/noConsole: local only
            console.error(err);
          }
          datadogRum.addError(err);
        },
        onCaughtError: (err) => {
          if (process.env.NODE_ENV === 'development') {
            // biome-ignore lint/suspicious/noConsole: local only
            console.error(err);
          }
          datadogRum.addError(err);
        },
        onRecoverableError: (err) => {
          if (process.env.NODE_ENV === 'development') {
            // biome-ignore lint/suspicious/noConsole: local only
            console.error(err);
          }
          datadogRum.addError(err);
        },
      });
      root.render(createElement(RenderIt));
    }
  }
});
